<template>
  <loader v-if="dataLoading" />

  <prime-dialog v-model:visible="dialog.banche.visible" :style="{ width: '1280px' }" :modal="true">
    <template #header>
      <h3>Aggiungi Banca</h3>
    </template>
    <div class="formgrid grid">
      <div class="field col-12 md:col-4">
        <label for="name">Nome</label>
        <prime-input-text id="name" v-model="data.newBanca.name" type="text" class="inputfield w-full" />
      </div>
      <div class="field col-12 md:col-4">
        <label for="iban">IBAN</label>
        <prime-input-text id="iban" v-model="data.newBanca.iban" type="text" class="inputfield w-full" />
      </div>
      <div class="field col-12 md:col-4">
        <label for="conto">Conto Team System</label>
        <prime-input-text id="conto" v-model="data.newBanca.code" type="text" class="inputfield w-full" />
      </div>
    </div>
    <div class="p-d-flex p-p-3 card" style="display: flex; justify-content: center; align-items: center;">
      <prime-button label="Aggiungi" icon="pi pi-plus" class="p-button-rounded p-button-success mr-2"
        @click="onAddNewContoAcquisto($event)" />
    </div>
  </prime-dialog>

  <prime-dialog v-model:visible="dialog.contiAcquisto.visible" :style="{ width: '1280px' }" :modal="true">
    <template #header>
      <h3>Aggiungi Conto Acquisto</h3>
    </template>

    <div class="formgrid grid">
      <div class="field col-12 md:col-6">
        <label for="name">Nome</label>
        <prime-input-text id="name" v-model="data.newContoAcquisto.name" type="text" class="inputfield w-full" />
      </div>
      <div class="field col-12 md:col-6">
        <label for="conto">Conto Team System</label>
        <prime-input-text id="conto" v-model="data.newContoAcquisto.code" type="text" class="inputfield w-full" />
      </div>
    </div>

    <div class="p-d-flex p-p-3 card" style="display: flex; justify-content: center; align-items: center;">
      <prime-button label="Aggiungi" icon="pi pi-plus" class="p-button-rounded p-button-success mr-2"
        @click="onAddNewContoAcquisto($event)" />
    </div>
  </prime-dialog>

  <div class="page">
    <tab-view>
      <tab-panel :header="headerTemplate" :selected="true">
        <template #header>
          <h3>Banche</h3>
        </template>
        <div class="p-d-flex p-jc-end p-p-3" style=" justify-content: end; display: flex; padding: 10px;">
          <prime-button label="Aggiungi" icon="pi pi-plus" class="p-button-rounded p-button-success"
            @click="dialog.banche.visible = true" />
        </div>
        <data-table :value="banche" dataKey="id" :paginator="true" :rows="10" :rowsPerPageOptions="[10, 20, 50]"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="{first} a {last} di {totalRecords}" responsiveLayout="scroll">
          <column field="name" header="Nome"></column>
          <column field="iban" header="IBAN"></column>
          <column field="code" header="Codice Conto"></column>
        </data-table>
      </tab-panel>

      <tab-panel :header="headerTemplate" :selected="true">
        <template #header>
          <h3>Conti acquisto</h3>
        </template>
        <div class="p-d-flex p-jc-end p-p-3" style=" justify-content: end; display: flex; padding: 10px;">
          <prime-button label="Aggiungi" icon="pi pi-plus" class="p-button-rounded p-button-success"
            @click="dialog.contiAcquisto.visible = true" />
        </div>

        <data-table :value="contiAcquisto" dataKey="id" :paginator="true" :rows="10" :rowsPerPageOptions="[10, 20, 50]"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="{first} a {last} di {totalRecords}" responsiveLayout="scroll">
          <column field="name" header="Nome"></column>
          <column field="code" header="Codice Conto"></column>
        </data-table>
      </tab-panel>
    </tab-view>
  </div>
</template>

<script>
import moment from 'moment';

import BancaService from '@/services/ask-management/utility-banche';
import ContoAquistoService from '@/services/ask-management/utility-conto-acquisto';

import Loader from '@/components/Loader.vue';

import PrimeButton from 'primevue/button';
import PrimeDialog from 'primevue/dialog';
import PrimeInputText from 'primevue/inputtext';
import TabView from 'primevue/tabview'; // Importa TabView
import TabPanel from 'primevue/tabpanel'; // Importa TabPanel

export default {
  components: {
    Loader,
    PrimeButton,
    PrimeDialog,
    PrimeInputText,
    TabView, // Aggiungi il componente TabView
    TabPanel // Aggiungi il componente TabPanel
  },

  data() {
    return {
      moment,
      currencyFormatter: new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: 'EUR'
      }),
      dataLoading: false,
      dialog: {
        banche: { visible: false },
        contiAcquisto: { visible: false }
      },
      banche: [],
      contiAcquisto: [],
      data: {
        newBanca: { name: '', iban: '', code: '' },
        newContoAcquisto: { name: '', code: '' }
      }
    }
  },

  created() {
    this.bancaService = new BancaService(this.$http, this.$eventBus);
    this.contoAcquistoService = new ContoAquistoService(this.$http, this.$eventBus);
    this.getBanche();
    this.getContiAcquisto();
  },

  methods: {
    onCloseBancaDialog() {
      this.dialog.banche.visible = false;
      this.resetBancaItem();
    },

    onCloseContoAcquistoDialog() {
      this.dialog.contiAcquisto.visible = false;
      this.resetContoAcquistoItem();
    },

    onAddNewBanca() {
      this.bancaService.create(this.data.newBanca).then(res => {
        if (res.success) {
          this.getBanche();
          this.dialog.banche.visible = false;
          this.resetBancaItem();
        } else {
          alert("Ci sono stati problemi durante l'inserimento");
        }
      });
    },

    onAddNewContoAcquisto() {
      this.contoAcquistoService.create(this.data.newContoAcquisto).then(res => {
        if (res.success) {
          this.getContiAcquisto();
          this.dialog.contiAcquisto.visible = false;
          this.resetContoAcquistoItem();
        } else {
          alert("Ci sono stati problemi durante l'inserimento");
        }
      });
    },

    resetBancaItem() {
      this.data.newBanca.name = '';
      this.data.newBanca.iban = '';
      this.data.newBanca.code = '';
    },

    resetContoAcquistoItem() {
      this.data.newContoAcquisto.name = '';
      this.data.newContoAcquisto.code = '';
    },

    getBanche() {
      this.dataLoading = true;
      this.bancaService.getAll().then(res => {
        this.banche = res.items;
      }).finally(() => {
        this.dataLoading = false;
      });
    },

    getContiAcquisto() {
      this.dataLoading = true;
      this.contoAcquistoService.getAll().then(res => {
        this.contiAcquisto = res.items;
      }).finally(() => {
        this.dataLoading = false;
      });
    },
  },

  computed: {},

  watch: {},
}
</script>

<style scoped>
.box-center {
  text-align: center;
}
</style>